import React from "react";
import { BiLoaderAlt } from "react-icons/bi";
import PropTypes from "prop-types";

const Loader = ({ modifyLoader = "text-white" }) => {
  return (
    <div className="grid size-full place-items-center">
      <BiLoaderAlt className={`mx-auto size-10 animate-spin ${modifyLoader}`} />
    </div>
  );
};
const FullScreenLoader = () => {
  return (
    <div className="grid h-screen w-full place-items-center bg-purple-D0B4FF">
      <BiLoaderAlt className="mx-auto size-10 animate-spin text-white" />
    </div>
  );
};
// FUNCTION TO SHOW LOADER ON SCREEN TILL RESPONSE FROM API NOT COMES
const CommonLoader = () => {
  return (
    <div className="absolute z-50 flex h-screen w-full items-center justify-center">
      <BiLoaderAlt className="size-10 animate-spin text-purple-6C36B0" />
    </div>
  );
};

Loader.propTypes = {
  modifyLoader: PropTypes.string
};
export { Loader, FullScreenLoader, CommonLoader };
